export enum FulfillmentType {
  Delivery = 'delivery',
  Pickup = 'pickup'
}
